import { createContext, useContext } from "react";

// ECRH-4226: broadcasts whether the Records scroll container is currently
// scrolling so that hover tooltips in each record item can be temporarily
// disabled. This prevents the MUI Tooltip popper from leaving stale/misaligned
// tooltips behind after the user scrolls while hovered over a record.
interface RecordsScrollContextValue {
  isScrolling: boolean;
}

const RecordsScrollContext = createContext<RecordsScrollContextValue>({
  isScrolling: false,
});

export const RecordsScrollProvider = RecordsScrollContext.Provider;

export const useRecordsScroll = () => useContext(RecordsScrollContext);
